"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Salutation = void 0;
/**
 *  Enum values for the salutation column.
 */
var Salutation;
(function (Salutation) {
    Salutation["Mister"] = "Dhr.";
    Salutation["Misses"] = "Mevr.";
    Salutation["Other"] = "Overig";
    Salutation["Unknown"] = "Onbekend";
})(Salutation = exports.Salutation || (exports.Salutation = {}));
//# sourceMappingURL=client.js.map